<template>
<div class="news">
    <div v-if="news.header" class="row">
        <h2>{{ news.header }}</h2>
    </div>
    <ol>
        <li v-for="(item, index) in news.news" v-bind:key="index">
            <h3>{{ item.header }}</h3>
            <span>{{ item.date }}</span>
            <p>{{ item.paragraph }}</p>
        </li>
    </ol>
</div>
</template>

<script>
export default {
    name: "News",
    props: {
        news: Object
    }
};
</script>

<style lang="scss" scoped>
ol {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 50px;
}

h2 {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 12px;
    margin-bottom: 14px;
}

h3 {
    font-weight: bold;
    font-size: 16px;
}

span,
p {
    font-size: 12px;
    line-height: 14px;
}

span {
    opacity: .6;
    margin-bottom: 4px;
    display: block;
}
</style>
